/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrInput from "@grapecity/wijmo.react.input"

import { generatePath } from "react-router"
// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { 運行管理メニューコード } from "../../../constant/menuCode"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import DateInput from "../../../components/InputWrapper/DateInput"
import {
  TTenkoListInfoGetRes,
  TTenkoListGetReq,
  TTenkoPrintTenkoboReq,
} from "../../../service/truckcontrol/tenko/TTenko"
import TenkoService from "../../../service/truckcontrol/tenko/tenkoService"
import BusyoService from "../../../service/master/busyo/busyoService"
import { RootState } from "../../../globalStore/rootreducer"
import dayjs from "dayjs"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import dateUtil from "../../../ts/util/dateUtil"
import {
  tenkoListExcelFormat,
  tenkoListPdfFormat,
} from "../../../ts/util/exportUtil"
import { e点呼区分 } from "../../../constant/enum/unko"
import { T乗務員マスタ } from "../../../components/ComboBox/ZyomuinComboBox"
import ZyomuinService from "../../../service/driver/zyomuinService"
import { TTenkoUrlParam } from "./TenkoRegister"

/**
 * 点呼一覧
 * @returns
 */
const TenkoList = () => {
  const history = useHistory()
  const location = useLocation()
  const { eigyobiStr: 営業日 } = useSelector((state: RootState) => state.date)
  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  let gridId = "TenkoList_GridId"

  //検索条件保持用
  const [preSearchCondition, setPreSearchCondition] =
    useState<TTenkoListGetReq>({} as TTenkoListGetReq)

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TTenkoListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TTenkoListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    // 検索ボタン押下時の検索条件を保持
    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new TenkoService().getList(currentSearchCondition)
      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態を解除
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TTenkoListGetReq = queryString.parse(location.search)
    set部所コード(query.部所コード ?? userInfo.部所コード ?? "")
    set日付(query.日付)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TTenkoListGetReq => {
    return {
      部所コード: 部所コード ?? undefined,
      日付: dateUtil.format(日付) ?? "",
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (searchCondition: TTenkoListGetReq) => {
    return {
      部所コード: wjCore.isNullOrWhiteSpace(searchCondition.部所コード ?? "")
        ? ""
        : searchCondition.部所コード,
      日付: wjCore.isNullOrWhiteSpace(searchCondition.日付 ?? "")
        ? ""
        : searchCondition.日付,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set日付(Date)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }
  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjGrid.FlexGrid) => {
    // header行に一行追加
    var extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (始業点呼Bindings.includes(c.binding)) {
          setHeaderText = "始業点呼"
        } else if (中間点呼Bindings.includes(c.binding)) {
          setHeaderText = "中間点呼"
        } else if (終業点呼Bindings.includes(c.binding)) {
          setHeaderText = "終業点呼"
        } else if (中間点呼２Bindings.includes(c.binding)) {
          setHeaderText = "中間点呼２"
        } else if (中間点呼３Bindings.includes(c.binding)) {
          setHeaderText = "中間点呼３"
        } else if (始業点呼２Bindings.includes(c.binding)) {
          setHeaderText = "始業点呼２"
        } else if (終業点呼２Bindings.includes(c.binding)) {
          setHeaderText = "終業点呼２"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        c.align = "left"
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
  }

  /**
   * 点呼記録簿印刷処理呼出し
   */
  const execPrintTenkobo = async () => {
    // stateから印刷条件を生成
    const currentPrintCondition: TTenkoPrintTenkoboReq = {
      抽出条件_部所コード: preSearchCondition.部所コード ?? "",
      抽出条件_日付: dateUtil.format(preSearchCondition.日付) ?? "",
    }
    // 印刷処理を実行
    printTenkobo(currentPrintCondition)
  }

  /**
   * 点呼記録簿印刷処理
   * @param printCondition 印刷条件
   */
  const printTenkobo = async (printCondition: TTenkoPrintTenkoboReq) => {
    setIsSearching(true) // 検索中状態に遷移

    try {
      const service = new TenkoService({ responseType: "blob" })
      const res = await service.printTenkobo(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(15)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [部所コード, set部所コード] = useState<string | null>()
  const [日付, set日付] = useState<string | null | undefined>(営業日)
  const [乗務員, set乗務員] = useState<
    | (Partial<T乗務員マスタ> & {
        displayMember: string
      })
    | null
  >()

  //#region [comboboxState]
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>() //#endregion

  // 乗務員
  const [乗務員List, set乗務員List] = useState<
    (Partial<T乗務員マスタ> & {
      displayMember: string
    })[]
  >() //#endregion

  const [comboBoxDataInitialized, setComboBoxDataInitialized] = useState(false)

  //#endregion

  const 始業点呼Bindings = [
    "始業実点呼日",
    "始業点呼時刻",
    "始業点呼方法区分名称1",
    "始業点呼結果フラグ",
  ]
  const 中間点呼Bindings = [
    "中間実点呼日",
    "中間点呼時刻",
    "中間点呼方法区分名称1",
    "中間点呼結果フラグ",
  ]
  const 終業点呼Bindings = [
    "終業実点呼日",
    "終業点呼時刻",
    "終業点呼方法区分名称1",
    "終業点呼結果フラグ",
  ]
  const 中間点呼２Bindings = [
    "中間２実点呼日",
    "中間２点呼時刻",
    "中間２点呼方法区分名称1",
    "中間２点呼結果フラグ",
  ]
  const 中間点呼３Bindings = [
    "中間３実点呼日",
    "中間３点呼時刻",
    "中間３点呼方法区分名称1",
    "中間３点呼結果フラグ",
  ]
  const 始業点呼２Bindings = [
    "始業２実点呼日",
    "始業２点呼時刻",
    "始業２点呼方法区分名称1",
    "始業２点呼結果フラグ",
  ]

  const 終業点呼２Bindings = [
    "終業２点呼日",
    "終業２点呼時刻",
    "終業２点呼方法区分名称1",
    "終業２点呼結果フラグ",
  ]

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      // new KubunService().getList(),
      new ZyomuinService().getList({
        退職フラグ: 0,
      }),
    ]).then(([部所ListRes, 乗務員ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      set乗務員List([
        {
          displayMember: "",
          社員氏名: "",
          社員ID: undefined,
        },
        ...乗務員ListRes.data.map((d) => ({
          ...d,
          displayMember: `${d.社員コード}: ${d.社員氏名}`,
        })),
      ])
      // コンボボックスは部所で絞る

      setComboBoxDataInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboBoxDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        set部所コード(userInfo.部所コード)
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboBoxDataInitialized])

  useEffect(() => {
    document.title = `点呼一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">点呼一覧</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-60rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <div className="search-condition-table">
                            <div className="search-condition-row">
                              <div className="w-15rem">
                                <ComboBox.Busyo
                                  placeholder="部所"
                                  isRequired={true}
                                  itemsSource={部所ItemSource}
                                  isLoadEnded={部所IsLoadEnded}
                                  setIsLoadEnded={set部所IsLoadEnded}
                                  listFilter={(d) => d.運行部所フラグ === 1}
                                  selectedValue={部所コード}
                                  setSelectedValue={set部所コード}
                                  ComboBox={部所ComboBox}
                                  setComboBox={
                                    set部所ComboBox
                                  }></ComboBox.Busyo>
                              </div>
                              <div className="w-10rem">
                                <DateInput
                                  placeholder="日付"
                                  id="日付"
                                  isRequired={true}
                                  value={日付}
                                  defaultValue={営業日}
                                  setValue={(v) => {
                                    set日付(v)
                                  }}></DateInput>
                              </div>

                              <div className="w-15rem">
                                <wjrInput.AutoComplete
                                  minLength={1}
                                  showDropDownButton={true}
                                  itemsSource={
                                    乗務員List
                                    //   ?.filter(
                                    //   (d) =>
                                    //     d.部所コード === 部所コード ||
                                    //     d.乗務員ID == null
                                    // )
                                  }
                                  selectedIndexChanged={(
                                    control: wjcInput.ComboBox,
                                    e: wjCore.EventArgs
                                  ) => {
                                    set乗務員(control.selectedItem)
                                  }}
                                  displayMemberPath={"displayMember"}
                                  selectedValuePath={"乗務員ID"}
                                  placeholder="乗務員名"
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col className="text-end">
                          <Button
                            type="submit"
                            disabled={isSearching}
                            onClick={async (e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              // 乗務員IDが選択されていた場合、そのIDの乗務員の点呼記録に移動する
                              if (乗務員?.乗務員ID != null) {
                                //次ページで必要となるので自分の行のデータのみ取得
                                setIsSearching(true) // 検索中状態に遷移
                                dispatch(clearAlert()) // アラートを非表示に

                                try {
                                  const res = await new TenkoService().getList({
                                    部所コード: 乗務員.部所コード,
                                    日付: dateUtil.format(日付) ?? "",
                                    乗務員ID: 乗務員.乗務員ID,
                                  })

                                  if (res.data == null) {
                                    dispatch(
                                      setWarningAlerts([
                                        "乗務員を特定できませんでした。",
                                      ])
                                    )
                                    return
                                  }

                                  history.push(
                                    generatePath(
                                      util.getMenuPath(
                                        運行管理メニューコード.点呼記録
                                      )[1],
                                      {
                                        zyomuin_id: 乗務員.乗務員ID,
                                        date:
                                          dayjs(日付).format("YYYY-MM-DD") ??
                                          dayjs(営業日).format("YYYY-MM-DD"),
                                        tenko_kbn: e点呼区分.始業点呼,
                                        tenko_count: 1,
                                      }
                                    ),
                                    {
                                      ...res.data[0],
                                    } as TTenkoListInfoGetRes
                                  )
                                } catch (error) {
                                  dispatch(setAlerts(error))
                                } finally {
                                  setIsSearching(false) // 検索中状態を解除
                                }
                              } else {
                                search()
                              }
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            検索
                          </Button>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={gridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  excelFormatItem={tenkoListExcelFormat}
                  pdfFormatItem={tenkoListPdfFormat}
                  headerComponent={
                    <>
                      {/* PCの場合一覧から遷移する */}
                      {/* <Link
                        to={
                          util.getMenuPath(運行管理メニューコード.点呼記録)[0]
                        }
                        onClick={() =>
                          gridPageHelper.savePageConditionData(
                            location.pathname
                          )
                        }>
                        <Button disabled={isSearching}>
                          <FontAwesomeIcon icon={faPlusSquare} />
                          点呼記録
                        </Button>
                      </Link> */}
                      <Button
                        className="btn-done"
                        // style={{ marginLeft: "1.5rem" }}
                        disabled={gridData.data.items.length <= 0}
                        //TODO:暫定
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          execPrintTenkobo()
                        }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                        点呼記録簿印刷
                      </Button>
                    </>
                  }>
                  <wjrGrid.FlexGridColumn
                    header=" "
                    allowMerging="true"
                    align="center"
                    width={90}
                    selectable={false}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        // 点呼記録
                        const url = util.getMenuPath(
                          運行管理メニューコード.点呼記録
                        )[1]

                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={() => {
                              //画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(
                                location.pathname
                              )

                              const params: TTenkoUrlParam = {
                                zyomuin_id:
                                  context.item.乗務員ID?.toString() ?? "",
                                date:
                                  dayjs(日付).format("YYYY-MM-DD") ??
                                  dayjs(営業日).format("YYYY-MM-DD"),
                                tenko_kbn: e点呼区分.始業点呼,
                                tenko_count:
                                  context.item.点呼回数?.toString() ?? "1",
                              }

                              //受け渡すパラメータ
                              history.push(generatePath(url, params), {
                                ...context.item,
                              } as TTenkoListInfoGetRes)
                            }}>
                            点呼記録
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="乗務員社員コード"
                    width={90}
                    header="社員番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="乗務員社員名"
                    width={130}
                    header="乗務員"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="運行数"
                    width={60}
                    header="運行">
                    {/* <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        return context.item.受注番号 ? <>○</> : <></>
                      }}
                    /> */}
                  </wjrGrid.FlexGridColumn>
                  {/* <wjrGrid.FlexGridColumn
                    binding="受注番号"
                    width={100}
                    header="受注番号"></wjrGrid.FlexGridColumn> */}
                  <wjrGrid.FlexGridColumn
                    binding="車番"
                    width={100}
                    header="車番"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="トレーラ車番"
                    width={100}
                    header="トレーラ"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="荷主名"
                    width={250}
                    header="荷主名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="積地市区町村"
                    width={120}
                    header="積地（PICK）市区町村"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="卸地市区町村"
                    width={120}
                    header="卸地（作業）市区町村"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="積日"
                    width={80}
                    header="積日（PICK日）">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        let d = ""
                        if (context.item.積日) {
                          d = dayjs(context.item.積日).format("MM/DD")
                          return <>{d}</>
                        } else {
                          return <></>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="卸日"
                    width={80}
                    header="卸日（作業日）">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        let d = ""
                        if (context.item.卸日) {
                          d = dayjs(context.item.卸日).format("MM/DD")
                          return <>{d}</>
                        } else {
                          return <></>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="点呼回数"
                    width={80}
                    header="回目">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) =>
                        context.item?.点呼回数 ? (
                          <>{context.item.点呼回数}回目</>
                        ) : (
                          <></>
                        )
                      }
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="始業実点呼日"
                    width={80}
                    multiLine={true}
                    header="点呼日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        let d = ""
                        if (context.item.始業実点呼日) {
                          d = dayjs(context.item.始業実点呼日).format("MM/DD")
                          return <>{d}</>
                        } else {
                          return <></>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="始業点呼時刻"
                    width={85}
                    multiLine={true}
                    header="点呼時刻">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        let t = ""
                        if (context.item.始業点呼時刻) {
                          t = dayjs(
                            dayjs(context.item.始業点呼日).add(
                              parseInt(context.item.始業点呼時刻),
                              "ms"
                            )
                          ).format("HH:mm")
                          return <>{t}</>
                        } else {
                          return <></>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="始業点呼方法区分名称1"
                    width={85}
                    header="点呼方法"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="始業点呼結果フラグ"
                    width={60}
                    header="結果">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        return context.item.始業点呼結果フラグ === 0 ? (
                          <>○</>
                        ) : context.item.始業点呼結果フラグ === 1 ? (
                          <>×</>
                        ) : (
                          <></>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="中間実点呼日"
                    width={80}
                    multiLine={true}
                    header="点呼日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        let d = ""
                        if (context.item.中間実点呼日) {
                          d = dayjs(context.item.中間実点呼日).format("MM/DD")
                          return <>{d}</>
                        } else {
                          return <></>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="中間点呼時刻"
                    width={85}
                    multiLine={true}
                    header="点呼時刻">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        let t = ""
                        if (context.item.中間点呼時刻) {
                          t = dayjs(
                            dayjs(context.item.中間点呼日).add(
                              parseInt(context.item.中間点呼時刻),
                              "ms"
                            )
                          ).format("HH:mm")
                          return <>{t}</>
                        } else {
                          return <></>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="中間点呼方法区分名称1"
                    width={85}
                    header="点呼方法"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="中間点呼結果フラグ"
                    width={60}
                    header="結果">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        return context.item.中間点呼結果フラグ === 0 ? (
                          <>○</>
                        ) : context.item.中間点呼結果フラグ === 1 ? (
                          <>×</>
                        ) : (
                          <></>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="終業実点呼日"
                    width={85}
                    multiLine={true}
                    header="点呼日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        let d = ""
                        if (context.item.終業実点呼日) {
                          d = dayjs(context.item.終業実点呼日).format("MM/DD")
                          return <>{d}</>
                        } else {
                          return <></>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="終業点呼時刻"
                    width={85}
                    multiLine={true}
                    header="点呼時刻">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        let t = ""
                        if (context.item.終業点呼時刻) {
                          t = dayjs(
                            dayjs(context.item.終業点呼日).add(
                              parseInt(context.item.終業点呼時刻),
                              "ms"
                            )
                          ).format("HH:mm")
                          return <>{t}</>
                        } else {
                          return <></>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="終業点呼方法区分名称1"
                    width={85}
                    header="点呼方法"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="終業点呼結果フラグ"
                    width={60}
                    header="結果">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkoListInfoGetRes>
                      ) => {
                        return context.item.終業点呼結果フラグ === 0 ? (
                          <>○</>
                        ) : context.item.終業点呼結果フラグ === 1 ? (
                          <>×</>
                        ) : (
                          <></>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}
export default TenkoList
